module.exports = __webpack_public_path__ + "img/m1-screenshot-09.32e259da.png";